const postToNative = (message) => {
    // Canal esperado por Flutter (JavaScriptChannel name: "Flutter")
    if (window?.Flutter?.postMessage) {
        window.Flutter.postMessage(message);
        return true;
    }

    // Compatibilidad si también se usa un contenedor React Native WebView
    if (window?.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(message);
        return true;
    }

    return false;
};

export const notifyNative = (event, payload = {}) => {
    try {
        const message = JSON.stringify({ event, payload });
        return postToNative(message);
    } catch (error) {
        console.error("Error enviando mensaje a la app nativa:", error);
        return false;
    }
};

const isValidHttpUrl = (value) => {
    try {
        const url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (_) {
        return false;
    }
};

export const openExternalLink = (url, source = "unknown") => {
    if (!isValidHttpUrl(url)) return false;

    const openedByNative = notifyNative("OPEN_EXTERNAL_URL", { url, source });

    if (!openedByNative) {
        window.open(url, "_blank", "noopener,noreferrer");
    }

    return true;
};